export const VERSION = '4.3.0-bowl';
export const GIT_HASH = 'ee2224b50d5206ec7cd1fd6c630a2623116d1057';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'bowl';
